export const CommonTextsENUSTranslations = {
  soon: 'Em breve',
  contactButton: 'Falar com vendas',
  plans: 'Planos',
  product: 'Produto',
  section: 'Setores',
  about: 'Quem somos',
  cases: 'Cases',
  resource: 'Recursos',
  accessButton: 'Acessar plataforma',
  startFreeButton: 'Comece grátis',
  requiredField: 'Campo obrigatório',
  privacyPolicy: 'Política de Privacidade',
};

export const CommonTextsPTBRTranslations = {
  soon: 'Em breve',
  contactButton: 'Falar com vendas',
  plans: 'Planos',
  product: 'Produto',
  section: 'Setores',
  about: 'Quem somos',
  cases: 'Cases',
  resource: 'Recursos',
  accessButton: 'Acessar plataforma',
  startFreeButton: 'Comece grátis',
  requiredField: 'Campo obrigatório',
  privacyPolicy: 'Política de Privacidade',
  termsOfUse: 'Termos de Uso',
};
